import {mapActions, mapGetters} from 'vuex'

const MENU_ITEMS = [
  {
    url: '/',
    label: 'Home'
  },
  {
    url: '/map',
    label: 'Peta Bencana'
  },
  {
    url: '/management',
    label: 'Kesiapsiagaan'
  },
  {
    url: '/report',
    label: 'Pasca Bencana'
  }
]

export default {
  name: 'HeadSection',
  data () {
    return {
      menuItems: MENU_ITEMS
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    path () {
      return this.$route.path
    }
  },
  methods: {
    ...mapActions('Auth', ['logout']),
    isActive (i) {
      if (i.url === '/') {
        return this.path === i.url
      }
      return this.path.indexOf(i.url) === 0
    },
    doLogout () {
      this.logout()
        .then(() => {
          this.$router.replace('/login')
        })
        .catch(() => {
          alert('Error logging out')
        })
    }
  }
}
